import axios from "axios";
import {endpoint} from "../../config/app.config";
import { clearCookie, getCookie, setParentDomainCookie } from "../../utils/cookies";

const { token, reset, sub, user } = getCookie()

export const getCareer = () => {
  clearCookie()
  return axios
    .get(`${endpoint}/api/career`, { withCredentials: false })
    .then((response) => {
      setParentDomainCookie(token, reset, sub, user)
      return response.data;
    })
    .catch((err) => {
      throw err;
    });
};
